export default __webpack_public_path__ + "static/media/t5.0209239b.jpeg";